import React from 'react';
import { ReactComponent as AvatarSVG } from '../images/avatar.svg';
import styles from './ProfileImage.module.css';

const ProfileImage = ({ avatarUrl, openFileDialog }) => {
  return (
    <button
      type="button"
      className={styles.imageContainer}
      onClick={openFileDialog}
    >
      <div className={styles.profileImage} data-testid="profile-image-container">
        {avatarUrl ? (
          <img src={avatarUrl} alt="user profile icon" />
        ) : (
          <AvatarSVG />
        )}
      </div>
      <div className={styles.camera}>
        <i className="fas fa-camera-alt" />
      </div>
    </button>
  );
};
export default ProfileImage;
